;(() => {
  function Datera(
    input,
    options = {
      value: void 0,
      divider: void 0,
      minYear: void 0,
      maxYear: void 0,
      freezeDates: void 0,
      disabledDates: void 0,
      enabledDates: void 0,
      startWeek: void 0,
      daysOfWeek: void 0,
      selectionType: void 0,
      theme: void 0
    }
  ) {
    options.value && (this.value = options.value.map((val) => new Date(val))),
      options.minYear && (this.minYear = options.minYear),
      options.maxYear && (this.maxYear = options.maxYear),
      options.disabledDates &&
        (this.disabledDates = options.disabledDates?.map(
          (val) => new Date(val)
        )),
      options.enabledDates &&
        (this.enabledDates = options.enabledDates?.map((val) => new Date(val))),
      options.startWeek && (this.startWeek = options.startWeek),
      options.daysOfWeek && (this.daysOfWeek = options.daysOfWeek),
      options.selectionType && (this.selectionType = options.selectionType),
      options.theme && (this.theme = options.theme),
      options.divider && (this.divider = options.divider),
      options.freezeDates && (this.freezeDates = options.freezeDates),
      (this.input =
        typeof input === 'string'
          ? document.querySelector(input) ||
            document.querySelector('.' + input) ||
            document.querySelector('#' + input)
          : input),
      this.input && (this.input.readOnly = !0)
  }
  ;(Datera.prototype = {
    input: null,
    value: [],
    divider: ' - ',
    freezeDates: false,
    selectionType: 'single',
    currentDay: new Date().getDate(),
    currentDate: new Date(),
    minYear: null,
    maxYear: null,
    minDate: null,
    maxDate: null,
    disabledDates: null,
    enabledDates: null,
    startWeek: 0,
    daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    theme: 'theme1-dark',
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ],
    calendarDays: [],
    calendarDOM: null,
    position: [],
    mount() {
      this.bindEvents(), this.getCalendarDays()
    },
    getGridDays() {
      var startCurrentDay = new Date(
        this.currentDate.getFullYear(),
        this.currentDate.getMonth(),
        1
      )
      var startCurrentDay = new Date(startCurrentDay)
      startCurrentDay.setDate(
        startCurrentDay - getDate() - startCurrentDay.getDay()
      )
    },
    placeCalendar() {
      let calendarBoundingRect
      this.calendarDOM &&
        ((calendarBoundingRect = this.calendarDOM?.getBoundingClientRect()),
        this.position[1] + calendarBoundingRect.height + this.position[3] >=
        window.innerHeight + window.scrollY
          ? this.calendarDOM.style.setProperty(
              '--position-y',
              this.position[1] - calendarBoundingRect.height + 'px'
            )
          : (this.calendarDOM.style.setProperty(
              '--position-x',
              this.position[0] + 'px'
            ),
            this.calendarDOM.style.setProperty(
              '--position-y',
              this.position[1] + this.position[3] + 'px'
            )))
    },
    bindEvents() {
      this.input.addEventListener('click', () => this.showCalendar())
      this.input.addEventListener('focus', () => this.showCalendar())
      window.addEventListener('scroll', () => {
        this.calculatePosition(), this.placeCalendar()
      })
      window.addEventListener('resize', () => {
        this.calculatePosition(), this.placeCalendar()
      })
    },
    hideCalendar(event) {
      this.calendarDOM.contains(event.target) ||
        this.input == event.target ||
        this.calendarDOM.classList.contains('hidden') ||
        this.calendarDOM.classList.add('hidden')
    },
    formatDisplayDate(date) {
      const day = ('0' + date.getDate()).slice(-2)
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const year = date.getFullYear()
      return `${day}-${month}-${year}`
    },
    displayValue() {
      this.selectionType == 'single' && this.value[0]
        ? (this.input.value = this.formatDisplayDate(this.value[0]))
        : ((this.selectionType == 'range' && this.value[0] && this.value[1]) ||
            (this.selectionType == 'list' && this.value.length)) &&
          (this.input.value = this.value
            .map(this.formatDisplayDate)
            .join(this.divider))
    },
    calculatePosition() {
      let inputRect = this.input.getBoundingClientRect()
      ;(this.position[0] = inputRect.left + window.screenX),
        (this.position[1] = inputRect.top + window.scrollY),
        (this.position[2] = inputRect.width),
        (this.position[3] = inputRect.height)
    },
    getSelectedValue() {
      return new Date(this.value[0])
    },
    getAvailableYears() {
      return (
        this.minYear || (this.minYear = new Date().getFullYear() - 100),
        this.maxYear || (this.maxYear = new Date().getFullYear() + 101),
        new Array(this.maxYear - this.minYear + 1)
          .fill(null)
          .map((y, i) => this.minYear + i)
      )
    },
    getCalendarDays() {
      this.calendarDays = []
      var selectedMonth = new Date(
        this.currentDate.getFullYear(),
        this.currentDate.getMonth(),
        1
      )
      let fromStartOfMonth = new Date(this.currentDate)
      var selectedMonth =
        (fromStartOfMonth.setDate(1 + this.startWeek - selectedMonth.getDay()),
        fromStartOfMonth.getMonth() == selectedMonth.getMonth() &&
          fromStartOfMonth.getDate() != 1 &&
          fromStartOfMonth.setDate(fromStartOfMonth.getDate() - 7),
        new Date(this.currentDate))

      const nextMonth = selectedMonth.getMonth() + 1
      selectedMonth.setDate(1)
      selectedMonth.setMonth(nextMonth)
      selectedMonth.getDay() - this.startWeek == 0
        ? selectedMonth.setDate(selectedMonth.getDate() - 1)
        : selectedMonth.setDate(
            selectedMonth.getDate() +
              (6 - selectedMonth.getDay() + this.startWeek)
          )
      return this.generateCalendarDays(fromStartOfMonth, selectedMonth)
    },
    generateCalendarDays(from, to) {
      const days = []
      let currentDay = new Date(from)

      while (currentDay <= to || days.length / 7 !== 6) {
        days.push(new Date(currentDay))
        currentDay.setDate(currentDay.getDate() + 1)
        if (days.length >= 42) {
          // HOT FIX
          break
        }
      }
      return days
    },
    generateCalendarWeeks(from, to) {
      let days = this.generateCalendarDays(from, to)
      let groupedWeeks = []
      for (let i = 0; i < days.length / 7; i++)
        for (let j = 0; j < 7; j++)
          groupedWeeks[i] || (groupedWeeks[i] = []),
            (groupedWeeks[i][j] = days[7 * i + j])
      return groupedWeeks
    },
    changeMonth(step) {
      1 == step
        ? 11 == this.currentDate.getMonth()
          ? (this.currentDate.setFullYear(this.currentDate.getFullYear() + 1),
            this.currentDate.setMonth(0))
          : this.currentDate.setMonth(this.currentDate.getMonth() + 1)
        : -1 == step &&
          (0 == this.currentDate.getMonth()
            ? (this.currentDate.setFullYear(this.currentDate.getFullYear() - 1),
              this.currentDate.setMonth(11))
            : this.currentDate.setMonth(this.currentDate.getMonth() - 1))
    },
    canNavigateBack() {
      return !(
        (this.minYear == this.currentDate.getFullYear() &&
          this.currentDate.getMonth() == 0) ||
        (this.minDate?.getFullYear() == this.currentDate.getFullYear() &&
          this.minDate?.getMonth() == this.currentDate.getMonth())
      )
    },
    canNavigateNext() {
      return !(
        (this.maxYear == this.currentDate.getFullYear() &&
          this.currentDate.getMonth() == 11) ||
        (this.maxDate?.getFullYear() == this.currentDate.getFullYear() &&
          this.maxDate?.getMonth() == this.currentDate.getMonth())
      )
    },
    myEvent: new CustomEvent('datera-datepicker'),
    showCalendar(revertToSelected = true) {
      if (revertToSelected && document.getElementById(this.input.id).value) {
        dateString = document.getElementById(this.input.id).value
        const [day, month, year] = dateString.split('-')
        const dateObject = new Date(year, month - 1, day)
        this.currentDate.setMonth(dateObject.getMonth())
        this.currentDate.setFullYear(dateObject.getFullYear())
      }
      this.calculatePosition(),
        this.calendarDOM || (this.calendarDOM = document.createElement('div')),
        // console.log(this.canNavigateBack(), this.canNavigateNext()),
        (this.calendarDOM.classList = 'datera--calendar ' + this.theme),
        (this.calendarDOM.innerHTML = `<div class="datera--controls"><button class="datera--month-decrement" ${
          this.canNavigateBack() ? '' : 'disabled'
        }><svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-chevron-left"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M15 6l-6 6l6 6" /></svg></button><div class="datera--control-selects"><select class="datera--month-select">${this.months.map(
          (month, i) =>
            `<option ${
              this.currentDate.getMonth() == i ? 'selected' : ''
            } value="${i}">${month}</option>`
        )}</select><select class="datera--year-select">${this.getAvailableYears().map(
          (year, i) =>
            `<option ${
              this.currentDate.getFullYear() == year ? 'selected' : ''
            } value="${year}">${year}</option>`
        )}</select></div><button class="datera--month-increment" ${
          this.canNavigateNext() ? '' : 'disabled'
        }><svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-chevron-right"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 6l6 6l-6 6" /></svg></button></div><div class="datera--grid">${new Array(
          7
        )
          .fill('')
          .map(
            (_, i) => `<p class="datera--day-of-week">${this.daysOfWeek[i]}</p>`
          )
          .join('')}</div><div class="datera--grid days"></div>`),
        this.calendarDOM
          .querySelector(`.${this.theme} .datera--year-select`)
          .addEventListener('change', () => {
            this.currentDate.setFullYear(
              this.calendarDOM.querySelector(
                `.${this.theme} .datera--year-select`
              ).value
            ),
              this.showCalendar(false)
          }),
        this.calendarDOM
          .querySelector(`.${this.theme} .datera--month-select`)
          .addEventListener('change', () => {
            const val = this.calendarDOM.querySelector(
              `.${this.theme} .datera--month-select`
            ).value
            this.currentDate.setMonth(val),
              this.currentDate.setMonth(val),
              this.showCalendar(false)
          }),
        this.calendarDOM
          .querySelector('.datera--month-decrement')
          .addEventListener('click', (e) => {
            e.stopPropagation(), this.changeMonth(-1), this.showCalendar()
          }),
        this.calendarDOM
          .querySelector('.datera--month-increment')
          .addEventListener('click', (e) => {
            e.stopPropagation(), this.changeMonth(1), this.showCalendar()
          }),
        this.renderCalendar(),
        this.placeCalendar(),
        this.calendarDOM.parentNode || document.body.append(this.calendarDOM)
    },
    isDisabledDate(dateObject) {
      return this.disabledDates
        ? this.disabledDates.find(
            (val) => val.toDateString() == dateObject.toDateString()
          )
        : !!this.enabledDates &&
            !this.enabledDates.find(
              (val) => val.toDateString() == dateObject.toDateString()
            )
    },
    freezeFutureDates(d) {
      if (this.freezeDates) {
        return d > new Date()
      }
      return false
    },
    renderCalendar() {
      ;(this.calendarDOM.querySelector(
        '.datera--grid.days'
      ).innerHTML = `${this.getCalendarDays()
        .map(
          (d) =>
            `<button ${
              this.isDisabledDate(d) || this.freezeFutureDates(d)
                ? 'disabled'
                : ''
            } class="datera--day ${
              new Date().toDateString() == d.toDateString() ? 'today' : ''
            } ${
              d.getMonth() != this.currentDate.getMonth() ? 'other' : 'current'
            } ${
              this.selectionType == 'single' &&
              this.value[0]?.toDateString() == d.toDateString()
                ? 'selected'
                : ''
            } ${
              this.selectionType == 'list' &&
              this.value.find((val) => val.toDateString() == d.toDateString())
                ? 'selected'
                : ''
            }  ${
              this.selectionType == 'range'
                ? `${
                    this.value[1] &&
                    this.value[0]?.toDateString() == d.toDateString()
                      ? 'start-range'
                      : this.value[0]?.toDateString() == d.toDateString()
                      ? 'selected'
                      : ''
                  } ${
                    this.value[1]?.toDateString() == d.toDateString()
                      ? 'end-range'
                      : ''
                  } ` +
                  (this.value[0]?.toDateString() != d.toDateString() &&
                  this.value[0] < d &&
                  this.value[1] > d
                    ? 'in-range'
                    : '')
                : ''
            } " datera-date="${d.toDateString()}"><div>${d.getDate()}</div></button>`
        )
        .join('')}`),
        this.calendarDOM
          .querySelector('.datera--grid.days')
          .querySelectorAll('.datera--day')
          .forEach((btn) =>
            btn.addEventListener('click', (e) => {
              e.stopPropagation(),
                this.onDatePicked(btn.getAttribute('datera-date'))
            })
          ),
        this.displayValue(),
        document.dispatchEvent(this.myEvent),
        window.addEventListener('click', (e) => this.hideCalendar(e))
    },
    onDatePicked(selectionDate) {
      const decodedSelectionDate = new Date(selectionDate)
      if (this.selectionType == 'range')
        if (this.value[0]) {
          if (this.value[1])
            (this.value[0] = decodedSelectionDate), (this.value[1] = void 0)
          else if (
            !this.value[1] &&
            this.value[0]?.toDateString() != decodedSelectionDate.toDateString()
          ) {
            let betweenDates = !1
            if (this.disabledDates)
              betweenDates = this.disabledDates.find(
                (dis) =>
                  (dis > this.value[0] && dis < decodedSelectionDate) ||
                  (dis < this.value[0] && dis > decodedSelectionDate)
              )
            else if (this.enabledDates) {
              let currentDate = new Date(
                this.value[0] > decodedSelectionDate
                  ? decodedSelectionDate
                  : this.value[0]
              )
              for (
                let endDate = new Date(
                  this.value[0] < decodedSelectionDate
                    ? decodedSelectionDate
                    : this.value[0]
                );
                currentDate <= endDate;

              ) {
                if (
                  !this.enabledDates.find(
                    (val) => val.toDateString() == currentDate.toDateString()
                  )
                ) {
                  betweenDates = !0
                  break
                }
                currentDate.setDate(currentDate.getDate() + 1)
              }
            }
            betweenDates
              ? (this.value = [decodedSelectionDate])
              : ((this.value[1] = decodedSelectionDate),
                this.value[0] > this.value[1] && this.value.reverse())
          }
        } else this.value[0] = decodedSelectionDate
      else
        this.selectionType == 'single'
          ? (this.value = [decodedSelectionDate])
          : this.selectionType == 'list' &&
            ((selectionDate = this.value.findIndex(
              (val) => val.toDateString() == decodedSelectionDate.toDateString()
            )) > -1
              ? this.value.splice(selectionDate, 1)
              : this.value.push(decodedSelectionDate))
      this.renderCalendar()
    },
    getCurrentMonth() {
      return this.value || new Date()
    }
  }),
    (window.Datera = Datera)
})()
